const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatCurrency = (value: number): string =>
  currencyFormat.format(value);

export const formatPercent = (value: number): string => `${value}%`;

export const NULL_DISPLAY = "-";
